import React from 'react';
import { Typography } from '@mui/material';

import { OrderedListProps } from './types';
import { styles } from './styles';

export const OrderedList: React.FC<OrderedListProps> = ({ list }) => (
    <div>
        <ol>
            {list.map((item) => (
                <li key={item.text}>
                    {item.text && (
                        <Typography
                            variant="body1"
                            css={styles.text}
                            dangerouslySetInnerHTML={{ __html: item.text }}
                        />
                    )}
                    {item.orderedList && <OrderedList list={item.orderedList} />}
                    {item.html && (
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{ __html: item.html }}
                        />
                    )}
                    {item.subtitleSecondary && (
                        <Typography variant="h4" css={styles.subtitleSecondary}>
                            {item.subtitleSecondary}
                        </Typography>
                    )}
                </li>
            ))}
        </ol>
        {list.map((item) =>
            item.unnumberedText ? (
                <Typography key={item.text} variant="body1">
                    {item.unnumberedText}
                </Typography>
            ) : null
        )}
    </div>
);
